import {
  Box,
  SimpleGrid,
  Stack,
  Text,
  Link as ChakraLink,
} from "@chakra-ui/layout";
import React, { FC, memo } from "react";
import { ISection } from "../models/type";
import { Link } from "gatsby";
import { Else, If, Then } from "react-if";

interface IProps {
  sectionItem: ISection;
}
const DropItem: FC<IProps> = (props) => {
  const { sectionItem } = props;
  return (
    <SimpleGrid columns={3} spacing={40}>
      <Box borderRight="1px" borderColor={"grey200"} p={"2rem"}>
        <Text mb={3} fontSize={"l"} fontWeight={600}>
          {sectionItem?.dropItems?.intro?.title}
        </Text>

        <Text mb={3} fontSize={"m"}>
          {sectionItem?.dropItems?.intro?.desc}
        </Text>

        <Link
          color={"primary"}
          to={sectionItem?.dropItems?.intro?.goTo?.to || "/"}
        >
          <Text fontSize={"m"} color={"primary"} fontWeight={700}>
            {sectionItem?.dropItems?.intro?.goTo?.text}
          </Text>
        </Link>
      </Box>
      <Box p={"2rem"}>
        {sectionItem?.dropItems?.headingLinks?.map((link, index) => (
          <Stack key={index} mb={"1.625rem"}>
            <If condition={link.isExternal}>
              <Then>
                <ChakraLink
                  href={`${link.to}`}
                  target={link.linkTarget || "_blank"}
                  fontSize={"m"}
                  color={"black"}
                  fontWeight={700}
                  _hover={{ textDecoration: "none" }}
                >
                  {link.text}
                </ChakraLink>
              </Then>
              <Else>
                <Link to={link.to || ""}>
                  <Text fontSize={"m"} color={"black"} fontWeight={700}>
                    {link.text}
                  </Text>
                </Link>
              </Else>
            </If>
          </Stack>
        ))}
      </Box>
      <Box p={"2rem"}>
        {sectionItem?.dropItems?.variantLinks?.map((link, index) => (
          <Stack mb={"1.625rem"} key={index}>
            <Link to={link.to || ""}>
              <Text fontSize={"m"} color={"black"} fontWeight={700}>
                {link.text}
              </Text>
            </Link>
          </Stack>
        ))}
      </Box>
    </SimpleGrid>
  );
};

export default memo(DropItem);
